export default __webpack_public_path__ + "static/media/forbidden.0d4ade70.svg";